module.exports = __webpack_public_path__ + "static/antd-table-expandable-f61720b5df1be5eaaff413722687c66f.png";